export default __webpack_public_path__ + "static/media/btn-prev.7600f6ec.svg";